import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The true difference between self publishing and using publishers",
  "description": "",
  "published": "2013-03-05T00:00:00.000Z",
  "redirect_from": ["/blog/the-true-difference-between-self-publishing-and-using-publishers/swizec/6047"],
  "categories": "Book, Business, Publishing, Self-publishing, Uncategorized, Writing",
  "hero": "./img/179-469789435_8efdc0e6c6.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://www.flickr.com/photos/sami73/469789435/"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "500px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "74.88789237668162%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'300\\'%20viewBox=\\'0%200%20400%20300\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2017l1%2019%201%208v7l1-3%201-4%201%204c-1%203-1%203%202%203%204%200%204%200%204%204v4H6c-5-1-6%200-6%201l4%201c6%200%206%201%206%2011-2%2017-2%2017-6%2018l-4%203c0%202%200%202%203%201%205-2%206%200%201%202l-4%204c0%202%204%203%204%201l2-1v8c0%2010%200%2010-3%2010H0v182h401V0H280a1023%201023%200%2000-124%202c-1-2-12-2-79-2H0v17m50%2022a929%20929%200%2000-7%20125l4%201c5%200%205%200%205-3v-2l7%201c9%200%209%201%208%203l6%201c19-2%2020-3%2018-5%200-2-9-2-11%201l-3%201h-3v-8l2-25c1-18%202-21%208-25%2014-10%2032%201%2029%2018%200%204-1%206-2%206l-2-1%202-1%201-1c0-1-6-2-11-1l-2-1%207-1c4%200%205%200%203-1-3%200-3-1-1-1l2-1%201-5c0-4-1-5-5-8-5-4-9-4-9%200v3l-1%206c0%204%200%204-1-3v-9h-3c-7%201-14%207-11%2010l3%202%201%203c0%203%203%205%208%204%203-1%204%200%203%203%200%202%200%202-4%200-4-1-5-1-4%202%200%201%201%202%204%202h3v7l2%208v2c-1%202%200%203%202%203s2-5%201-6v-8c0-6%200-7%202-7%201%200%202%201%201%202h1c1-2%203%200%201%202l-1%203c0%202%203%202%204%201%203-3%205-3%205%200%200%202%200%203-1%202h-1v4l1%201v13c0%205-1%207-2%207l-1%202%202%201%201%201-2%201c-2-1-2%200-4%203-2%205-3%2014-1%2014s3-4%203-7v-4l8%202h9l2-26c2-52%203-64%205-65%202%200%202%2017%201%2045a387%20387%200%2000-2%2025l-2%201%201%201%201%2010%201%209c3%200%208-8%209-13%203-9%2010-13%2024-12h6l-4-13-1-3-4-17c-2-3%205-6%209-4l4%202V97l1-16%202-22%201-12h-3l-4%201h-1c-2-2-34-5-35-3l-1%2012c0%2014-1%2025-2%2025-3-1-2-7%201-32%200-6-1-7-13-7h-8l-1%203-1%201-3-1-2-1c0-2-1-2-7-2l-3%201c0%203%200%204%202%203%201%200%202%200%201%201l-1%201-2%203c-1%203-1%204-4%204-7%200-7%200-6-8l-1-7-16-2-17-3c-1-1-1%200-2%203m3%2024l8%201a1227%201227%200%2000-8-1m132%2022a2000%202000%200%2001-2%2060c-2%202-1%209%201%2010%203%202%203%201%204-14a796%20796%200%20010-48c-1-9-3-14-3-8m-54%20122l-1%204-1%204v1l1%202c0%204%202%205%207%204l8-2c4%201%204%200%204-2l-8-12-2%201h-8m-29%204l2%202c2%201%202%201%200%201-3%200-3%200-3%204l1%204c2%200%205-1%204-2%200-1%202-3%205-3v1c-1%201-1%201%202%201h1c-2%201-2%201%202%201s4%200%202%202c-1%201-1%201%201%201l3-1%201-1v-1l1-1%202-2%203-1h-3l-2-3c0-2-2-2-9-1-4%200-5%201-5%202%201%202-2%201-3-1-1-3-5-4-5-2m-50%201l-9%201c6%200%205%203-2%204-3%201-3%201%202%201%203%200%205%200%204-1l10-1c11%200%2020-2%2012-2-6%200-4-1%203-2l6-1h-7l-19%201m6%2019l-10%201c-7%200-7%201-6%2017a1223%201223%200%20002%2026c0%206%201%207%206%207a31%2031%200%200013-2c1-1%202-5%201-11l-3-11c-3-7-3-8-2-9l1-3%202-1c6%201%208%200%207-2v-6c2-8%200-9-11-6m53-1c0%203%200%2010%202%2012v2l-1-1v1l-2%201c-2%201%205%206%2010%206s5%200%203-2v-2h5c2%200%202%200-1-1h-3v-7l-1-8c-1-1-12-3-12-1m4%2031c-3%202-3%207-1%2010l2%204c1%203%205%206%208%204%202-1%202-8%200-15-2-4-4-5-9-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/29c82e1c087b4ebcf775b702fce4365d/ca0a1/179-469789435_8efdc0e6c6.webp 223w", "/static/29c82e1c087b4ebcf775b702fce4365d/75680/179-469789435_8efdc0e6c6.webp 445w", "/static/29c82e1c087b4ebcf775b702fce4365d/b0a15/179-469789435_8efdc0e6c6.webp 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/29c82e1c087b4ebcf775b702fce4365d/853b2/179-469789435_8efdc0e6c6.jpg 223w", "/static/29c82e1c087b4ebcf775b702fce4365d/0a4fe/179-469789435_8efdc0e6c6.jpg 445w", "/static/29c82e1c087b4ebcf775b702fce4365d/41099/179-469789435_8efdc0e6c6.jpg 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/29c82e1c087b4ebcf775b702fce4365d/41099/179-469789435_8efdc0e6c6.jpg",
                "alt": "Writing, by Sami KeinÃ¤nen",
                "title": "Writing, by Sami KeinÃ¤nen",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Writing, by Sami KeinÃ¤nen`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Right now I'm writing two books at once and yes that was a `}<em parentName="p">{`terrible`}</em>{` idea. Please avoid doing this if you at all can.`}</p>
    <p>{`One book I'm working on with a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Publishing",
        "title": "Publishing"
      }}>{`publisher`}</a>{`, the other I'm `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Self-publishing",
        "title": "Self-publishing"
      }}>{`self-publishing`}</a>{`. Both are interesting processes, but I have noticed one colossal difference between the two:`}</p>
    <p>{`Self-publishing -> November 2012 to March 2013 (5 months) -> 104 hours worked. Includes researching, writing, marketing, everything. About 40 pages written.`}</p>
    <p>{`Publisher -> late January 2013 to March 2013 (1.5 months) -> 101 hours worked. Just researching and writing. About 100 pages written.`}</p>
    <p>{`Might be the tight chapter deadlines I keep missing, might be the nice project coordinator lady asking me what the fuck do I think I'm doing via email every couple of weeks.`}</p>
    <p>{`But them's the facts. I get more writing done when working with a publisher.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://acwpublishinghouse.wordpress.com/2013/02/18/author-development-residual-income-through-book-publishing/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/146263368_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://acwpublishinghouse.wordpress.com/2013/02/18/author-development-residual-income-through-book-publishing/"
        }}>{`Author Development: Residual Income Through Book Publishing`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.pbs.org/mediashift/2013/02/10-proofreading-tips-for-self-publishers-058.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/148423968_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.pbs.org/mediashift/2013/02/10-proofreading-tips-for-self-publishers-058.html"
        }}>{`10 Proofreading Tips For Self-Publishers`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://selfpubauthors.com/2013/03/03/if-a-publisher-offers-you-a-contract-for-your-self-published-book-will-you-be-forced-by-amazon-to-refund-past-customers-who-bought-it/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/149463175_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://selfpubauthors.com/2013/03/03/if-a-publisher-offers-you-a-contract-for-your-self-published-book-will-you-be-forced-by-amazon-to-refund-past-customers-who-bought-it/"
        }}>{`If A Publisher Offers You a Contract for Your Self-Published Book, Will You Be Forced (By Amazon) To Refund Past Customers Who Bought It?`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://annaldavis.net/2013/02/26/writer-undercover-four-submission-tips/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/148295322_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://annaldavis.net/2013/02/26/writer-undercover-four-submission-tips/"
        }}>{`Writer, Undercover: Four Submission Tips`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=4497a9c1-c8b8-4f00-881f-5f49a8ed775d",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      